import { Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import { PagingSearchFieldArgument } from 'src/lib/utilities/api/patterns/pagination/paging-search-field.argument';
import { PagingArgument } from 'src/lib/utilities/api/patterns/pagination/paging.argument';
import {
	WorkQueueTrackerResponseModel,
	WorkQueueTrackerResponseModel_ClassTransform_Type,
} from '../work-queue/work-queue-entity.model';

export enum StudentUpdateTrackerStatus {
	Approved = 1,
	Rejected = 2,
	Pending = 0,
}

export class RequestedInformationModel {
	by_id: number;
	by_name: string;
	@Transform(dateTransformer)
	on: Date;
}

export function RequestedInformationModel_ClassTransform_Type() {
	return RequestedInformationModel;
}

export class StudentUpdateTrackerItemModel {
	request_id: number;
	field: string;
	@Type(RequestedInformationModel_ClassTransform_Type)
	requested: RequestedInformationModel;
	institute: {
		id: number;
		title: string;
		state: string;
		itype_shortcode: string;
	};
	student: {
		uid: number;
		first_name: string;
		last_name: string;
	};
	proposed_value: unknown;
	current_value: unknown;
	status: StudentUpdateTrackerStatus;
	@Type(RequestedInformationModel_ClassTransform_Type)
	completed: RequestedInformationModel;
	proofs: { proof_id: number; url: string }[];
	@Type(WorkQueueTrackerResponseModel_ClassTransform_Type)
	work_queue: WorkQueueTrackerResponseModel[];
	rejection_message: string;
}

export function StudentUpdateTrackerItemModel_ClassTransform_Type() {
	return StudentUpdateTrackerItemModel;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface StudentUpdateTrackerPagingArgument extends PagingArgument<StudentUpdateTrackerSearchArgument> {}

export interface StudentUpdateTrackerSearchArgument {
	student_uid: PagingSearchFieldArgument;
	student_first_name: PagingSearchFieldArgument;
	student_last_name: PagingSearchFieldArgument;
	field: PagingSearchFieldArgument;
	requested_on: PagingSearchFieldArgument;
	requested_by_name: PagingSearchFieldArgument;
	completed_on?: PagingSearchFieldArgument;
	completed_by_name?: PagingSearchFieldArgument;
	institute_title: PagingSearchFieldArgument;
	institute_state: PagingSearchFieldArgument;
	institute_itype_shortcode: PagingSearchFieldArgument;
	work_queue: PagingSearchFieldArgument;
	status?: PagingSearchFieldArgument;
}

export class StudentUpdateTrackerResponseModel {
	success: boolean;
	count: number;
	@Type(StudentUpdateTrackerItemModel_ClassTransform_Type)
	results: StudentUpdateTrackerItemModel[];
}
